import type { Sources } from '../types/data-types'
import useData from './data-service'

export default function useSources(): Sources | undefined {
  const { sources } = useData() || {}
  return sources
}
